import React from "react";
import { CardLayout } from "components/cardLayout";
import { CardItem } from "components/cardItem";
import { CardSubItem } from "components/cardSubItem";
import { apartment, Assembly, PadWrap } from "assets/images"
import { bed1 } from "assets/images"
import { hourIcon, truckIcon, boxIcon, fuelIcon } from "assets/images"
import moment from "moment";
import "./SuperDealsMoveDetailsCard.scss"
// import Popup from "components/Popup/Popup";
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
import {  getEstFlowEstimateDetails } from "../../core/services/moveDetailsByCustomer"

import { Popup } from "components/Popup"
import { on } from "cluster";
import Spinner from '../spinner/spinner';



export interface SuperDealsMoveDetailsCardProps {

}

export interface SuperDealsMoveDetailsCardState {
    open1?: boolean;
    open2?: boolean;
    open3?: boolean;
    Estimator:any;
    loading:boolean;
}

class SuperDealsMoveDetailsCard extends React.Component<SuperDealsMoveDetailsCardProps, SuperDealsMoveDetailsCardState> {
    private _isMounted: boolean = false;
    constructor(props: SuperDealsMoveDetailsCardProps) {
        super(props);
        this.state = {
            open1: false,
            open2: false,
            open3: false,
            Estimator: [],
            loading:true
        };
    }

    handleOpen1 = () => {
        this.setState({ open1: true });
    };
    handleOpen2 = () => {
        this.setState({ open2: true });
    };
    handleOpen3 = () => {
        this.setState({ open3: true });
    };
    async fetchData() {
        var CID = localStorage.getItem("CID")||"0";
        let response = await getEstFlowEstimateDetails(CID)
        console.log("III")
        console.log(response);
        this.setState({Estimator:response[0],loading:false})
        console.log("EstimatorDetails:"+JSON.stringify(this.state.Estimator));
        localStorage.setItem("EstimatorDetails",JSON.stringify(this.state.Estimator))
    }
    
    componentDidMount() {
      this._isMounted = true;
      this.fetchData();
    }
    
    componentWillUnmount() {
      this._isMounted = false;
    }
    render() {
        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        var address = object.address + ", #" + object.Unit
        var weekday = moment(object.MoveDate).format("d")
        var isSuper = parseInt(weekday) <= 3 ? 1 : 0;

        
       // loadEstimatedHours: “0.25”
       // unloadEstimatedHours: “0.25"
      //  travelHours: “1.00”
        var moveTime = parseFloat(this.state.Estimator?.loadEstimatedHours)+parseFloat(this.state.Estimator?.unloadEstimatedHours)+parseFloat(this.state.Estimator?.travelHours)
        var travelTime = parseFloat(this.state.Estimator?.travelHours);
        var starttime = (travelTime*60)/2
       // var addHRcontent = "Time starts when movers get to your home and finishes when movers finish the move at your destination. Pay as you go on additional hours $" + {this.state.Estimator.loadRate}  + "/hr with 15 min increments."
        

        
        // if(isNaN(moveTime))
        // {
        //     return <Spinner />;
        //     //return < CircularProgress/>
        // }
        // else {    
        return (this.state.loading?<Spinner/>:
            <CardLayout>
                {/* <CardItem itemLabel={"Address "} itemValue={"Move Date"} />
                <CardSubItem rightLabel={address} leftLabel={
                    
                   localStorage.getItem("notsure")==="1"?
"Not Sure"
                   : moment(object.MoveDate).format("MM/DD/YY")} /> */}
                {/* <div className="item-details">
                    <CardItem itemLabel={"Move Details "} />
                </div> */}
                {/* <div className="move-icons">
                    <div className="icon-detail">
                        <img src={apartment} />
                        <p>Apartment</p>
                    </div>
                    <div className="icon-detail">
                        <img src={bed1} />
                        <p>1 Bedroom</p>
                    </div>
                    <div className="icon-detail">
                        <img src={local} />
                        <p>{object.MoveType}</p>
                    </div>
                </div> */}
                {/* <div className="superdeal-heading">
                    {
                        isSuper ? <h3>All Inclusive Super Deal Package*</h3>
                            : <h3>All Inclusive  Package*</h3>
                    }

                </div> */}
                <div className="superdeal-list">
                    <div className="superdeal-detail">
                        <div className="img-bg"><img src={hourIcon} alt="" /></div>
                        <div style={{paddingTop:"1em"}}>
                            <p>{moveTime||3} Hours of Moving</p>
            {/* <p><span>Additional hours are {Number(this.state.Estimator.loadRate)?.toFixed(2)}/hr</span></p> */}
                            </div>
                    
                    </div>
                    <div className="superdeal-detail">
                        <div className="img-bg"><img src={truckIcon} alt="" /></div>
                        <div style={{width:"100%"}}><p>{this.state.Estimator?.loadTrucks} Truck{parseFloat(this.state.Estimator?.loadTrucks)>1?"(s)":""}/{this.state.Estimator?.loadCrewSize} Movers</p></div>
                        {/* <div>
                            <SimpleLineIcon name="info" onClick={() => this.handleOpen1()} />
                            <Popup open={this.state.open1}
                                onClose={() => this.setState({ open1: false })}
                                title={moveTime + " Hours of Moving"}
                                content={"Time starts when movers get to your home and finishes when movers finish the move at your destination. Pay as you go on additional hours $" + this.state.Estimator.loadRate  + "/hr with 15 min increments."}
                            />
                        </div> */}
                    </div>
                    <div className="superdeal-detail">
                        <div className="img-bg"><img src={PadWrap} alt="" /></div>
            <div><p>Pad Wrapping</p></div>
                     
                    </div>
                    <div className="superdeal-detail">
                        <div className="img-bg"><img src={Assembly} alt="" /></div>
                        <div><p>Disassembly/Assembly</p></div>
                   
                    </div>
                    {/* <ul>
                        <li>3 Hours of Moving <SimpleLineIcon name="info" onClick={() => this.handleOpen1()} />
                            <Popup open={this.state.open1}
                                onClose={() => this.setState({ open1: false })}
                                title={"3 Hours of Moving"}
                                content={`Time starts when movers get to your home and finishes when movers finish the move at your destination.
                                Pay as you go on additional hours $99/hr with 15 min increments.`}
                            />
                        </li>
                        <li>2 Movers and 1 Truck</li>
                        <li>Basic Materials <SimpleLineIcon name="info" onClick={() => this.handleOpen2()} />
                            <Popup open={this.state.open2??/lp;.//}
                            onClose={() => this.setState({ open2:
                                .+kl-[+p;/8i] false })}
                                title={"Basic Materials"}
                                content={`Materials included: 1 roll of tape, 1 mattress bag and 1 tv carton.`}
                            />
                        </li>
                        <li>Travel and Fuel <SimpleLineIcon name="info" onClick={() => this.handleOpen3()} />
                            <Popup open={this.state.open3}
                            onClose={() => this.setState({ open3: false })}
                                title={"Travel and Fuel"}
                                content={`Travel time is 1 hour for local moves. This includes 30 min to reach your current address,
                         and 30 min to return from your destination. Fuel is included in travel costs.`}
                            />
                        </li>
                    </ul> */}
                </div>
            </CardLayout>
        );
                   
    }
}

export default SuperDealsMoveDetailsCard;